
define('modules/application/wizard/steps/zoneStep/complexZoneStep/audioVideoZoneStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../complexZoneStep",
  "./audioVideoZoneStep/zoneDetailView",
  "./audioVideoZoneStep/zoneModel",
  "./audioVideoZoneStep/zonesMenuView",
  "../../../classes/amplifierAndLoudSpeakers",
  "../../../classes/amplifierCommand"
],

function(
  app,
  Backbone,
  jQueryUi,
  complexZoneStep,
  ZoneDetailView,
  ZoneModel,
  ZonesMenuView,
  amplifierAndLoudSpeakers,
  amplifierCommand) {

  var Views        = _.extend({}, complexZoneStep.Views);

  Views.Content    = Views.Content.extend({
    addConstructors : function() {
      complexZoneStep.Views.Content.prototype.addConstructors.apply(this);
      this.ZoneDetailView = ZoneDetailView;
      this.ZonesMenuView  = ZonesMenuView;
    }
  });

  var audioVideoZoneStep = _.extend({}, complexZoneStep, {
    objClass      : "audioVideoZoneStep",
    Model         : complexZoneStep.Model.extend({

      addConstructors                     : function() {
        complexZoneStep.Model.prototype.addConstructors.apply(this);
        this.ZoneModel                = ZoneModel;
        this.ZoneDetailView           = ZoneDetailView;
        this.ZonesMenuView            = ZonesMenuView;
        this.amplifierAndLoudSpeakers = amplifierAndLoudSpeakers;
        this.amplifierCommand         = amplifierCommand;
      },

      initialize                          : function() {
        complexZoneStep.Model.prototype.initialize.apply(this);
        this.get("stepEventAggregator").unbind("zoneStatusCheck:requested",  this.checkZonesStatus);
        this.get("stepEventAggregator").bind("zoneStatusCheck:requested",    this.checkZonesStatus, this);
      },

      checkZonesStatus                     : function() {
        if ( (this.collection.checkZonesStatus()) && (this.checkAdditionalZones()) )
          this.get("stepEventAggregator").trigger('collection:validated');
        else
          this.get("stepEventAggregator").trigger('collection:unvalidated');
      },

      checkAdditionalZones                : function() {
        var validCollection = true;
        for (var i=0;i<this.additionalZones.length;i++)
          if (this.additionalZones[i].role!=="separator" && !this.additionalZones[i].isValid())
          {
            validCollection = false;
            break;
          }
        return validCollection;
      },

      getZoneNumber                       : function(zoneName) {
        var zoneNumber = -301;

        if      (zoneName==="IDS_WAV8_5_1")
          zoneNumber = -305;
        else if (zoneName==="IDS_WAV8_5_2")
          zoneNumber = -304;
        else if (zoneName==="IDS_WAV8_5_3")
          zoneNumber = -303;
        else if (zoneName==="IDS_WAV8_5_4")
          zoneNumber = -302;
        else if (zoneName==="IDS_W1_9111")
          zoneNumber = -301;
        else if (zoneName==="IDS_WAV8_5_5")
          zoneNumber = -300;

        return zoneNumber;
      },

      duplicateSelectedZone               : function() {
        var maxZoneNumber = BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxZoneNumber") : 4;

        if (this.collection.length<maxZoneNumber)
        {
          var selectedModel = this.collection.filter(function(currentModel){
            return currentModel.get("selected");
          });

          //Creating base model
          var modelToAdd = new this.ZoneModel(
            _.extend(
              selectedModel[0].toJSON(),
              {number : this.collection.length+1}
            )
          );

          var k=2;
          var nameFound;
          while (!nameFound) {
            for (var i=0; i<this.collection.models.length; i++) {
              if(modelToAdd.get("name").indexOf('{defaultName}')===0)
              {
                modelToAdd.set("name", '{defaultName} '+modelToAdd.get("number"));
                nameFound=true;
                break;
              }
              else
              {
                if (this.collection.models[i].get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))==(modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))+"("+k+")"))
                {
                  break;
                }
                else
                {
                  if (i==this.collection.models.length-1)
                  {
                    nameFound=true;
                    modelToAdd.set("name", modelToAdd.get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"))+"("+k+")");
                  }
                }
              }
            }
            if (!nameFound)
              k++;
          }

          //////////////////////////////////
          //Creating new this.amplifierAndLoudSpeakersModel
          //////////////////////////////////
          var amplifierAndLoudSpeakersModelToAdd    = new this.amplifierAndLoudSpeakers.Model(
            _.extend({stepEventAggregator :  this.get("stepEventAggregator"), zoneEventAggregator : this.get("zoneEventAggregator")}, selectedModel[0].get("amplifierAndLoudSpeakersModel").attributes)
          );
          modelToAdd.set("amplifierAndLoudSpeakersModel", amplifierAndLoudSpeakersModelToAdd);

          var amplifierCommandModelToAdd            = new this.amplifierCommand.Model(
            _.extend({stepEventAggregator :  this.get("stepEventAggregator"), zoneEventAggregator : this.get("zoneEventAggregator")}, selectedModel[0].get("amplifierCommandModel").attributes)
          );
          modelToAdd.set("amplifierCommandModel", amplifierCommandModelToAdd);

          //Adding new this.model to the collection
          this.addZone(modelToAdd);
          this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        }
        else {
          alert($.i18n._("IDS_W1_9090"));
        }
      },

      deliverModel                        : function() {
        var additionalZones = this.additionalZones,
            regularZones    = this.collection.models,
            dataProvider    = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            zonesItems, zoneToPush, modelToAnalyse,
            i=0, j=0, l=0, m=0;

        BticinoS4B.solution.audioVideo.zones = this;
        BticinoS4B.Instances.Models.ApplicationModel.set("zones", BticinoS4B.solution.audioVideo.zones);
        BticinoS4B.solution.audioVideo.additionalZones = additionalZones;
        BticinoS4B.Instances.Models.ApplicationModel.set("additionalZones", BticinoS4B.solution.audioVideo.additionalZones);

        zonesItems          = BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") : [];

        //Additional zones
        for (i=0; i<additionalZones.length; i++)
        {
          if (additionalZones[i].role!=="separator")
          {
            zoneToPush = {
              name   : additionalZones[i].get("name"),
              number : additionalZones[i].get("number"),
              items: []
            };

            //Sources and vdes zone
            if (additionalZones[i].get("name")==="IDS_WAV8_5_1")
            {
              //Apartment interface section
              if(additionalZones[i].get("apartmentInterfaceModel"))
              {
                modelToAnalyse = additionalZones[i].get("apartmentInterfaceModel");
                if (modelToAnalyse.get("value"))
                {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("partOfKit"),
                    productCode        : modelToAnalyse.get("productCode"),
                    productLabel       : modelToAnalyse.get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("packageClassLabel"),
                    packageClassId     : modelToAnalyse.get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("price"),
                    specialVars        : modelToAnalyse.get("specialVars")
                  });

                  for (j=0; j<modelToAnalyse.get("secondaryProducts").length; j++)
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("partOfKit"),
                      productCode        : modelToAnalyse.get("secondaryProducts")[j].get("productCode"),
                      productLabel       : modelToAnalyse.get("secondaryProducts")[j].get("productLabel"),
                      packageClassLabel  : modelToAnalyse.get("secondaryProducts")[j].get("packageClassLabel"),
                      packageClassId     : modelToAnalyse.get("secondaryProducts")[j].get("packageClassId"),
                      quantity           : 1,
                      price              : modelToAnalyse.get("secondaryProducts")[j].get("price"),
                      specialVars        : modelToAnalyse.get("secondaryProducts")[j].get("specialVars")
                    });
                  }
                }
              }

              //VDE section
              if(additionalZones[i].get("vdesModel"))
              {
                modelToAnalyse = additionalZones[i].get("vdesModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId     : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price"),
                    specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars"),
                    isVde              : 'true'
                  });

                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId     : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price,
                      specialVars        : modelToAnalyse.get("collection").models[j].get("accessory").specialVars
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId     : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price,
                      specialVars        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].specialVars
                    });
                  }
                }
              }

              zonesItems.push(zoneToPush);
            }
            //Internals section
            else if (additionalZones[i].get("name")==="IDS_WAV8_5_2")
            {
              var telephonyReservedPositions = 0;

              //telephony section
              if(additionalZones[i].get("telephonyModel"))
              {
                modelToAnalyse = additionalZones[i].get("telephonyModel");

                if (modelToAnalyse.get("value"))
                {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("partOfKit"),
                    productCode        : modelToAnalyse.get("productCode"),
                    productLabel       : modelToAnalyse.get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("packageClassLabel"),
                    packageClassId     : modelToAnalyse.get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("price"),
                    specialVars        : modelToAnalyse.get("specialVars")
                  });
                  telephonyReservedPositions += 8;

                  if (modelToAnalyse.get("accessories").urbanLineExpansion.value)
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").urbanLineExpansion.partOfKit,
                      productCode        : modelToAnalyse.get("accessories").urbanLineExpansion.productCode,
                      productLabel       : modelToAnalyse.get("accessories").urbanLineExpansion.productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").urbanLineExpansion.packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").urbanLineExpansion.packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("accessories").urbanLineExpansion.price,
                      specialVars        : modelToAnalyse.get("accessories").urbanLineExpansion.specialVars
                    });

                  if (modelToAnalyse.get("accessories").urbanLineProtection.value)
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").urbanLineProtection.partOfKit,
                      productCode        : modelToAnalyse.get("accessories").urbanLineProtection.productCode,
                      productLabel       : modelToAnalyse.get("accessories").urbanLineProtection.productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").urbanLineProtection.packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").urbanLineProtection.packageClassId,
                      quantity           : modelToAnalyse.get("accessories").urbanLineProtection.value,
                      price              : modelToAnalyse.get("accessories").urbanLineProtection.price,
                      specialVars        : modelToAnalyse.get("accessories").urbanLineProtection.specialVars
                    });

                  if (modelToAnalyse.get("accessories").expansion1.value)
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").expansion1.partOfKit,
                      productCode        : modelToAnalyse.get("accessories").expansion1.productCode,
                      productLabel       : modelToAnalyse.get("accessories").expansion1.productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").expansion1.packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").expansion1.packageClassId,
                      quantity           : modelToAnalyse.get("accessories").expansion1.value,
                      price              : modelToAnalyse.get("accessories").expansion1.price,
                      specialVars        : modelToAnalyse.get("accessories").expansion1.specialVars
                    });
                    telephonyReservedPositions += 8;
                  }
                  if (modelToAnalyse.get("accessories").expansion2.value)
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").expansion2.partOfKit,
                      productCode        : modelToAnalyse.get("accessories").expansion2.productCode,
                      productLabel       : modelToAnalyse.get("accessories").expansion2.productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").expansion2.packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").expansion2.packageClassId,
                      quantity           : modelToAnalyse.get("accessories").expansion2.value,
                      price              : modelToAnalyse.get("accessories").expansion2.price,
                      specialVars        : modelToAnalyse.get("accessories").expansion2.specialVars
                    });
                    telephonyReservedPositions += 8;
                  }
                  if (modelToAnalyse.get("accessories").expansion1.value && modelToAnalyse.get("accessories").powerSupply.value)
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").powerSupply.value.partOfKit,
                      productCode        : modelToAnalyse.get("accessories").powerSupply.value.productCode,
                      productLabel       : modelToAnalyse.get("accessories").powerSupply.value.productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").powerSupply.value.packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").powerSupply.value.packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("accessories").powerSupply.value.price,
                      specialVars        : modelToAnalyse.get("accessories").powerSupply.value.specialVars
                    });


                  if (modelToAnalyse.get("accessories").vct.value)
                  {
                    /*
                      Segnalzione Mantis 05130: AUDIOVIDEO - IRYDE since 5th need supplementary power supply 346020
                    */

                    var numberVctWithSupply = 0;
                    var numberVctNormalSupply = modelToAnalyse.get("accessories").vctQuantity;

                    if (numberVctNormalSupply > 4) {
                      numberVctWithSupply = numberVctNormalSupply - 4;
                      numberVctNormalSupply =  4;
                    }

                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").vct.value[0].partOfKit,
                      productCode        : modelToAnalyse.get("accessories").vct.value[0].productCode,
                      productLabel       : modelToAnalyse.get("accessories").vct.value[0].productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").vct.value[0].packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").vct.value[0].packageClassId,
                      quantity           : numberVctNormalSupply,
                      price              : modelToAnalyse.get("accessories").vct.value[0].price,
                      specialVars        : modelToAnalyse.get("accessories").vct.value[0].specialVars
                    });

                    if (numberVctWithSupply > 0) {
                      dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                        partOfKit          : modelToAnalyse.get("accessories").vct.value[1].partOfKit,
                        productCode        : modelToAnalyse.get("accessories").vct.value[1].productCode,
                        productLabel       : modelToAnalyse.get("accessories").vct.value[1].productLabel,
                        packageClassLabel  : modelToAnalyse.get("accessories").vct.value[1].packageClassLabel,
                        packageClassId     : modelToAnalyse.get("accessories").vct.value[1].packageClassId,
                        quantity           : numberVctWithSupply,
                        price              : modelToAnalyse.get("accessories").vct.value[1].price,
                        specialVars        : modelToAnalyse.get("accessories").vct.value[1].specialVars
                      });
                    }

                    for (l=0; l<modelToAnalyse.get("accessories").vct.value[0].secondaryProducts.length; l++)
                    {
                      if (BticinoS4B.Instances.Models.ApplicationModel.get("maxNonPoweredVct")<modelToAnalyse.get("accessories").vctQuantity) {
                        dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                          partOfKit          : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].partOfKit,
                          productCode        : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].productCode,
                          productLabel       : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].productLabel,
                          packageClassLabel  : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].packageClassLabel,
                          packageClassId     : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].packageClassId,
                          quantity           : modelToAnalyse.get("accessories").vctQuantity-BticinoS4B.Instances.Models.ApplicationModel.get("maxNonPoweredVct"),
                          price              : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].price,
                          specialVars        : modelToAnalyse.get("accessories").vct.value[0].secondaryProducts[l].specialVars
                        });
                      }
                    }

                  }

                  if (modelToAnalyse.get("accessories").vctAccessory.value)
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("accessories").vctAccessory.value.partOfKit,
                      productCode        : modelToAnalyse.get("accessories").vctAccessory.value.productCode,
                      productLabel       : modelToAnalyse.get("accessories").vctAccessory.value.productLabel,
                      packageClassLabel  : modelToAnalyse.get("accessories").vctAccessory.value.packageClassLabel,
                      packageClassId     : modelToAnalyse.get("accessories").vctAccessory.value.packageClassId,
                      quantity           : modelToAnalyse.get("accessories").vctQuantity,
                      price              : modelToAnalyse.get("accessories").vctAccessory.value.price,
                      specialVars        : modelToAnalyse.get("accessories").vctAccessory.value.specialVars
                    });
                }
              }
              BticinoS4B.solution.audioVideo.telephonyReservedPositions = telephonyReservedPositions;
              BticinoS4B.Instances.Models.ApplicationModel.set("telephonyReservedPositions", BticinoS4B.solution.audioVideo.telephonyReservedPositions);

              //Handsets section
              if(additionalZones[i].get("handsetsModel"))
              {
                modelToAnalyse = additionalZones[i].get("handsetsModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId     : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price"),
                    specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
                  });

                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit        : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price,
                      specialVars        : modelToAnalyse.get("collection").models[j].get("accessory").specialVars
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price,
                      specialVars        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].specialVars
                    });
                  }
                }
              }
              zonesItems.push(zoneToPush);
            }
            //SCS section
            else if (additionalZones[i].get("name")==="IDS_WAV8_5_3")
            {
              //Vpe devices section
              if(additionalZones[i].get("vpeDevicesModel"))
              {
                modelToAnalyse = additionalZones[i].get("vpeDevicesModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId  : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price")
                  });

                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price
                    });
                  }
                }
              }

              //Web server section
              if(additionalZones[i].get("webServerModel"))
              {
                modelToAnalyse = additionalZones[i].get("webServerModel");
                if (modelToAnalyse.get("value"))
                {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("partOfKit"),
                    productCode        : modelToAnalyse.get("productCode"),
                    productLabel       : modelToAnalyse.get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("packageClassLabel"),
                    packageClassId  : modelToAnalyse.get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("price")
                  });

                  for (j=0; j<modelToAnalyse.get("secondaryProducts").length; j++)
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("secondaryProducts")[j].get("partOfKit"),
                      productCode        : modelToAnalyse.get("secondaryProducts")[j].get("productCode"),
                      productLabel       : modelToAnalyse.get("secondaryProducts")[j].get("productLabel"),
                      packageClassLabel  : modelToAnalyse.get("secondaryProducts")[j].get("packageClassLabel"),
                      packageClassId  : modelToAnalyse.get("secondaryProducts")[j].get("packageClassId"),
                      quantity           : 1,
                      price              : modelToAnalyse.get("secondaryProducts")[j].get("price")
                    });
                  }
                }
              }
              zonesItems.push(zoneToPush);
            }
            else if (additionalZones[i].get("name")==="IDS_WAV8_5_4")
            {
              //Sources section
              if(additionalZones[i].get("sourcesModel"))
              {
                modelToAnalyse = additionalZones[i].get("sourcesModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId  : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price"),
                    specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
                  });

                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price,
                      specialVars        : modelToAnalyse.get("collection").models[j].get("accessory").specialVars
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price,
                      specialVars        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].specialVars
                    });
                  }
                }
              }
              zonesItems.push(zoneToPush);
            }
            else if (additionalZones[i].get("name")==="IDS_WAV8_5_5")
            {
              //Touch screens section
              if(additionalZones[i].get("touchScreenModel"))
              {
                modelToAnalyse = additionalZones[i].get("touchScreenModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
                {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId  : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price"),
                    specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
                  });

                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price
                    });
                  }
                }
              }

              //Main commands section
              if(additionalZones[i].get("mainCommandModel"))
              {
                modelToAnalyse = additionalZones[i].get("mainCommandModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId  : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price"),
                    specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
                  });

                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price
                    });
                  }
                }
              }

              //Amplifier radio commands section
              if(additionalZones[i].get("amplifierRadioCommandModel"))
              {
                modelToAnalyse = additionalZones[i].get("amplifierRadioCommandModel");
                for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
                  dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                    partOfKit          : modelToAnalyse.get("collection").models[j].get("partOfKit"),
                    productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                    productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                    packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                    packageClassId     : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                    quantity           : 1,
                    price              : modelToAnalyse.get("collection").models[j].get("price"),
                    specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
                  });
                  
                  if (modelToAnalyse.get("collection").models[j].get("accessory"))
                  {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("accessory").partOfKit,
                      productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                      packageClassId     : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                      quantity           : modelToAnalyse.get("collection").models[j].get("accessoryValue"),
                      price              : modelToAnalyse.get("collection").models[j].get("accessory").price
                    });
                  }

                  for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                    dataProvider.addItemsToZone(additionalZones[i].get("number"), additionalZones[i].get("name"), {
                      productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                      partOfKit          : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].partOfKit,
                      productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                      packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                      packageClassId     : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                      quantity           : 1,
                      price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price
                    });
                  }
                }
              }
              zonesItems.push(zoneToPush);
            }
          }
        }

        //Regular zones
        for (i=0; i<regularZones.length; i++)
        {
          zoneToPush = {
            name   : regularZones[i].get("name").replace("{defaultName}", $.i18n._("IDS_WTR1001_9003")),
            number : regularZones[i].get("number"),
            items: []
          };

          if (regularZones[i].get("amplifierAndLoudSpeakersModel"))
          {
            modelToAnalyse = regularZones[i].get("amplifierAndLoudSpeakersModel");
            for (j=0; j<modelToAnalyse.get("collection").models.length; j++)
            {
              dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                packageClassId     : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                quantity           : 1,
                price              : modelToAnalyse.get("collection").models[j].get("price"),
                specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
              });

              dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                packageClassId     : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                quantity           : modelToAnalyse.get("collection").models[j].get("accessoryValue"),
                price              : modelToAnalyse.get("collection").models[j].get("accessory").price
              });
              
              for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                  productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                  productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                  packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                  packageClassId     : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                  quantity           : 1,
                  price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price
                });
              }
              
              for (l=0; l<modelToAnalyse.get("collection").models[j].get("accessory").secondaryProducts.length; l++) {
                dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                  productCode        :modelToAnalyse.get("collection").models[j].get("accessory").secondaryProducts[l].productCode,
                  productLabel       :modelToAnalyse.get("collection").models[j].get("accessory").secondaryProducts[l].productLabel,
                  packageClassLabel  :modelToAnalyse.get("collection").models[j].get("accessory").secondaryProducts[l].packageClassLabel,
                  packageClassId     :modelToAnalyse.get("collection").models[j].get("accessory").secondaryProducts[l].packageClassId,
                  quantity           : modelToAnalyse.get("collection").models[j].get("accessoryValue"),
                  price              :modelToAnalyse.get("collection").models[j].get("accessory").secondaryProducts[l].price
                });
              }
            }
          }

          if (regularZones[i].get("amplifierCommandModel"))
          {
            modelToAnalyse = regularZones[i].get("amplifierCommandModel");
            for (j=0; j<modelToAnalyse.get("collection").models.length; j++) {
              dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                productCode        : modelToAnalyse.get("collection").models[j].get("productCode"),
                productLabel       : modelToAnalyse.get("collection").models[j].get("productLabel"),
                packageClassLabel  : modelToAnalyse.get("collection").models[j].get("packageClassLabel"),
                packageClassId     : modelToAnalyse.get("collection").models[j].get("packageClassId"),
                quantity           : 1,
                price              : modelToAnalyse.get("collection").models[j].get("price"),
                specialVars        : modelToAnalyse.get("collection").models[j].get("specialVars")
              });

              if (modelToAnalyse.get("collection").models[j].get("accessory"))
              {
                dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                  productCode        : modelToAnalyse.get("collection").models[j].get("accessory").productCode,
                  productLabel       : modelToAnalyse.get("collection").models[j].get("accessory").productLabel,
                  packageClassLabel  : modelToAnalyse.get("collection").models[j].get("accessory").packageClassLabel,
                  packageClassId     : modelToAnalyse.get("collection").models[j].get("accessory").packageClassId,
                  quantity           : 1,
                  price              : modelToAnalyse.get("collection").models[j].get("accessory").price
                });
              }

              for (l=0; l<modelToAnalyse.get("collection").models[j].get("secondaryProducts").length; l++) {
                dataProvider.addItemsToZone(regularZones[i].get("number"), regularZones[i].get("name"), {
                  productCode        : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productCode,
                  productLabel       : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].productLabel,
                  packageClassLabel  : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassLabel,
                  packageClassId     : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].packageClassId,
                  quantity           : 1,
                  price              : modelToAnalyse.get("collection").models[j].get("secondaryProducts")[l].price
                });
              }
            }
          }

          zonesItems.push(zoneToPush);
        }

        var product;
        var retrieveProductCode   = function(item) {return item.productCode;};
        var checkNonZeroQuantity  = function(item) {return item.quantity>0;};
        var sumQuantities         = function(memo, item){return memo + item.quantity;};

        for (i=0; i<zonesItems.length; i++)
        {
          if (zonesItems[i].items instanceof Array)
          {
            zonesItems[i].items   = _.filter(zonesItems[i].items, checkNonZeroQuantity);

            /*Grouping products*/
            zonesItems[i].items   = _.groupBy(zonesItems[i].items, retrieveProductCode);

            /*Sum quantities*/
            for (product in zonesItems[i].items)
              zonesItems[i].items[product][0].totalQuantity = _.reduce(zonesItems[i].items[product], sumQuantities, 0.00);
          }
        }
        BticinoS4B.solution.audioVideo.zonesItems = zonesItems;
        BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems", BticinoS4B.solution.audioVideo.zonesItems);
      },

      loadProject                         : function(model) {
        var currentFilter        = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");
        this.collection = new this.ZoneCollection([], {stepEventAggregator:this.get("stepEventAggregator")});

        //Load externals zone
        if(model.externals)
        {
          this.loadAdditionalZone(
            _.extend(
              {name        : "IDS_WAV8_5_1", number : -305},
              model.externals
            )
          );
          number = -305;
        }

        //Load internals zone
        if(model.internals)
        {
          this.loadAdditionalZone(
            _.extend(
              {name        : "IDS_WAV8_5_2", number : -304},
              model.internals
            )
          );
          number = -304;
        }

        //Load command and actuators zone
        if(model.commandsAndActuators)
        {
          this.loadAdditionalZone(
            _.extend(
              {name        : "IDS_WAV8_5_3", number : -303},
              model.commandsAndActuators
            )
          );
          number = -303;
        }

        //Load sources zone
        if(model.sources)
        {
          this.loadAdditionalZone(
            _.extend(
              {name        : "IDS_WAV8_5_4", number : -302},
              model.sources
            )
          );
          number = -302;
        }

        //Load scs devices zone
        if(model.commands)
        {
          this.loadAdditionalZone(
            _.extend(
              {name        : "IDS_WAV8_5_5", number : -300},
              model.commands
            )
          );
          number = -300;
        }

        if (currentFilter>=3 && model.zones)
          for (var i=0; i<model.zones.length; i++)
          {
            this.loadZone(model.zones[i]);
            number = model.zones[i].number;
            window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", number);
          }

        this.get("stepEventAggregator").trigger("zone:loaded");
        this.get("stepEventAggregator").trigger("collection:initialized");
        this.get("stepEventAggregator").trigger("zoneStatusCheck:requested");

        if (currentFilter<3)
          window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", -305);
        else
          window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", number);
      }
    }),
    Views         : Views
  });

  // Required, return the module for AMD compliance
  return audioVideoZoneStep;

});